import { Table, Cell, Header } from "../system/table";
import { HisInformationListItem } from "./HisInformationListItem";
import { HisInformationItem } from ".";
import Enumerable from "linq";

export class HisInformationTable {
  keys: string[];
  items: HisInformationListItem[];

  constructor(public table: Table) {
    this.keys = this.tableToHisInfoKeys(table);
    this.items = this.tableToHisInfoListItems(table);
  }

  private tableToHisInfoKeys(table: Table): string[] {
    return table.headers.map(x => x.value);
  }

  private tableToHisInfoListItems(table: Table): HisInformationListItem[] {
    const items = table.rows.map(x => this.cellsToHisInfoItems(x.cells, table.headers));
    return items.map(x => Object.freeze(this.createHisInformationListItem(x, table.headers)));
  }

  private cellsToHisInfoItems(cells: Cell[], headers: Header[]): HisInformationItem[] {
    return cells
      .map((c, i) => ({ c, h: headers[i] }))
      .map(({ c, h }) => Object.freeze(new HisInformationItem(h.value, c.text)));
  }

  /**
   * HisInfoListItemBehaviorで非表示の項目を適用しないように分離している
   * ※非表示の診療科コードでフィルターする要件があるのでどこかしらに保持はしたい
   */
  private createHisInformationListItem(items: HisInformationItem[], headers: Header[]): HisInformationListItem {
    const invisibleKeys = Enumerable.from(headers).where(h => !h.isVisible).select(h => h.value).toArray();
    const visibleItems = Enumerable.from(items).where(i => invisibleKeys.indexOf(i.name) < 0).toArray();
    const invisibleItems = Enumerable.from(items).where(i => invisibleKeys.indexOf(i.name) >= 0).toArray();
    return new HisInformationListItem(visibleItems, invisibleItems);
  }
}
